import { CloseIcon } from '@chakra-ui/icons';
import { Button, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, IconButton } from '@chakra-ui/react';
import Spinner from 'components/spinner/Spinner';
import { useFormik } from 'formik';
import { useState } from 'react';
import { postApi } from 'services/api';
import { generateValidationSchema } from 'utils';
import CustomForm from 'utils/customForm';
import { ToastContainer, toast } from "react-toastify";
import { FcCancel } from "react-icons/fc";
import * as yup from 'yup'

const Add = (props) => {
    const [isLoding, setIsLoding] = useState(false)
//console.log(props)

    const initialFieldValues = Object.fromEntries(
        (props?.leadData?.fields || []).map(field => [field?.name, ''])
    );
    const initialValues = {
        ...initialFieldValues,
        createBy: JSON.parse(localStorage.getItem('user'))._id
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: yup.object().shape(generateValidationSchema(props?.leadData?.fields)),
        onSubmit: (values, { resetForm }) => {
            AddData();
        },
    });

    const { errors, touched, values, handleBlur, handleChange, handleSubmit, setFieldValue, } = formik

    const AddData = async () => {
        try {
            setIsLoding(true);
    
            // List of leadRemarks that require Date-Time
            const requiredDateTimeRemarks = [
                "followUp",
                "visitScheduled",
                "visitReschedule",
                "videoCallScheduled",
                "videoCallReschedule",
                "OfficeVisitSchedule",
                "OfficeVisitReschedule",
            ];
    
            // Check if leadRemark requires Date-Time and if it's missing
            if (requiredDateTimeRemarks.includes(values.leadRemark) && !values?.dateTime) {
                // alert("Date-Time is required for the selected lead remark.");
                 toast.error("Date-Time is required for the selected lead remark.", {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    icon: <FcCancel />,
                                    style: {
                                      backgroundColor: "#fffff",
                                      color: "red",
                                      fontSize: "16px",
                                      borderRadius: "8px",
                                    },
                                  });

                setIsLoding(false);
                return;
            }
    
            let response = await postApi("api/form/add", { 
                ...values, 
                moduleId: props?.leadData?._id 
            });
    
            if (response.status === 200) {
                props.onClose();
                formik.resetForm();
                props.setAction((pre) => !pre);
                toast.success("Lead Added successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: "✅",
                    style: {
                      backgroundColor: "#fffff", // Green background
                      color: "green",
                      fontSize: "16px",
                      borderRadius: "8px",
                    },
                  });
            }
        } catch (e) {
            //console.log(e);
        } finally {
            setIsLoding(false);
        }
    };

    const handleCancel = () => {
        formik.resetForm();
        props.onClose()
    }

    return (
        <div>
            <Drawer isOpen={props.isOpen} size={props.size}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader alignItems={"center"} justifyContent='space-between' display='flex'  >
                        Add Lead
                        <IconButton onClick={props.onClose} icon={<CloseIcon />} />
                    </DrawerHeader>
                    <DrawerBody>
                        <CustomForm moduleData={props.leadData} values={values} setFieldValue={setFieldValue} handleChange={handleChange} handleBlur={handleBlur} errors={errors} touched={touched} />
                    </DrawerBody>
                    <DrawerFooter>
                        <Button sx={{ textTransform: "capitalize" }} size="sm" disabled={isLoding ? true : false} variant="brand" type="submit" onClick={handleSubmit}                        >
                            {isLoding ? <Spinner /> : 'Save'}
                        </Button>
                        <Button
                            variant="outline"
                            colorScheme='red' size="sm"
                            sx={{
                                marginLeft: 2,
                                textTransform: "capitalize",
                            }}
                            onClick={handleCancel}
                        >
                            Close
                        </Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
            <ToastContainer />
        </div>
    )
}

export default Add
